module.exports = __webpack_public_path__ + "img/passport_background.fd3d4dee.png";